import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

const PLAYFUL_TAB_CLASSNAME = 'data-[state=active]:-translate-y-px data-[state=active]:bg-[var(--color-mission)] data-[state=active]:font-extrabold data-[state=active]:text-white data-[state=active]:shadow-[0_3px_0_var(--color-mission-dark)]';

const TABS = [
  {
    label: 'Desafio',
    value: 'desafios',
    url: '/desafio-da-semana/desafios'
  },
  {
    label: 'Ranking por região',
    value: 'ranking-por-regiao',
    url: '/desafio-da-semana/ranking-por-regiao'
  },
  {
    label: 'Ranking por participante',
    value: 'ranking-por-participante',
    url: '/desafio-da-semana/ranking-por-participante'
  },
  {
    label: 'Resultados',
    value: 'resultados',
    url: '/desafio-da-semana/resultados'
  }
];

export default function ChallengeTab({ selectedTab }) {
  const navigate = useNavigate();

  const handleTabChange = value => {
    const tab = TABS.find(item => item.value === value);
    if (tab) navigate(tab.url);
  };

  return (
    <Tabs
      className="mb-6"
      value={selectedTab}
      onValueChange={handleTabChange}
    >
      <TabsList className="border border-neutral-lighter bg-white">
        {TABS.map(tab => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            className={PLAYFUL_TAB_CLASSNAME}
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
